import React from 'react';
import styles from './Tile.scss';

const Tile = ({ imageSrc, title, onClick }) => {
  return (
    <div className={`${styles.container} ${!imageSrc ? styles.noImage : ''}`} 
         onClick={onClick} 
         role="button" 
         tabIndex={0} 
         onKeyDown={(e) => e.key === 'Enter' && onClick()}>
      {imageSrc && <img src={imageSrc} alt={title} className={styles.image} />}
      <div className={styles.title}>{title}</div>
    </div>
  );
};

export default Tile;